import { useEffect, useState } from 'react';
import useSalesBotStore from '@/stores/SalesBotStore';
import { toast } from 'sonner';
import { useShallow } from 'zustand/react/shallow';

import { saveAutopilotSettings } from '@/hooks/sales-bot';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

const AutopilotHumanHandover = () => {
  const [promptValue, setPromptValue] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const { humanHandoverPrompt, updateHumanHandoverPrompt } = useSalesBotStore(
    useShallow((state) => ({
      humanHandoverPrompt: state.humanHandoverPrompt,
      updateHumanHandoverPrompt: state.updateHumanHandoverPrompt,
    }))
  );

  // Initialize prompt value from store when it's available
  useEffect(() => {
    if (humanHandoverPrompt) {
      setPromptValue(humanHandoverPrompt);
    }
  }, [humanHandoverPrompt]);

  const handleSavePrompt = async () => {
    try {
      if (promptValue.trim() === '') {
        toast.error('Please enter a prompt');
        return;
      }

      setIsSaving(true);
      await toast.promise(
        saveAutopilotSettings({
          autopilot_human_handover_criteria_prompt: promptValue,
        }),
        {
          loading: 'Saving prompt...',
          success: () => {
            updateHumanHandoverPrompt(promptValue);
            setIsSaving(false);
            return 'Human handover prompt saved successfully';
          },
          error: (error) => {
            setIsSaving(false);
            return error.response?.data?.message || 'Failed to save prompt';
          },
        }
      );
    } catch (error) {
      toast.error('Failed to save prompt');
      setIsSaving(false);
    }
  };

  return (
    <div className='flex h-full flex-col p-6'>
      <div className='mb-4'>
        <h2 className='text-lg font-semibold'>Human Handover Prompt</h2>
        <p className='text-sm text-muted-foreground'>
          Configure when the autopilot should transfer conversations to a human
          agent.
        </p>
      </div>
      <div className='flex flex-1 flex-col'>
        <Textarea
          value={promptValue}
          onChange={(e) => setPromptValue(e.target.value)}
          placeholder='Enter your human handover criteria prompt here...'
          className='custom-scrollbar mb-4 h-full min-h-[63vh] resize-none'
        />
        <Button
          onClick={handleSavePrompt}
          disabled={isSaving || promptValue.trim() === ''}
          className='w-64 self-end'
        >
          {isSaving ? 'Saving...' : 'Save Prompt'}
        </Button>
      </div>
    </div>
  );
};

export default AutopilotHumanHandover;
